import React from 'react'

import Layout from '../layouts/layout'
import SEO from '../components/seo'
import TitleHeader from '../components/titleheader'
import SecondaryNav from '../components/secondarynav'
import BorderedBox from '../components/borderedbox'
import { trackPageData, getPageDetails } from '../analytics'

import whiteImage from '../assets/images/white-pencil.png'
import whiteImageMb from '../assets/images/white_pencil_mb.png'



class ChairmanLetters extends React.PureComponent {
  constructor(props) {
    super(props)

    let dataManager = {
      pageDetails: {},
    }
    if (typeof window !== `undefined`) {
      if (window.dataManager) {
        dataManager = window.dataManager
      }
    }
    dataManager.pageDetails = getPageDetails()
  }

  componentDidMount() {
    trackPageData()
    this.addTouchEventListeners();

  }  
  componentWillUnmount() {
    this.removeTouchEventListeners();
  }
 
  addTouchEventListeners = () => {
    document.addEventListener("touchstart", this.handleTouchStart, true);
  };
 
  removeTouchEventListeners = () => {
    document.removeEventListener("touchstart", this.handleTouchStart, true);
  };
 
  handleTouchStart = (event) => {
    // Select all list items dynamically
    const listItems = document.querySelectorAll(".card-position");
 
    // Remove 'active' class from all items
    listItems.forEach((li) => li.classList.remove("active"));
 
    // Find the touched <li> and add the active class
    const closestLi = event.target.closest(".card-position");
    if (closestLi) {
      closestLi.classList.add("active");
    }
  };


  render() {
    return (
      <Layout>
        <SEO
          title="Chairman's Letters | The Children's Place Corporate Website"
          description="Chairman's Letters | The Children's Place Corporate Website."
        />

        {/* Page Title & Header Image */}
        <div class="row mb-12">
          <div class="col-12">
            <TitleHeader
              image={whiteImage}
              mbheaderimage={whiteImageMb}
             class="letterMain" title="CHAIRMAN'S LETTERS" />
          </div>
        </div>
        {/* End Page Title & Header Image */}

        <div class="row mb-12 no-gutters">
          <div class="col-lg-12 col-md-12 col-sm-12 text-left">
            <br />
            <BorderedBox classname="mb-n-border text-left letter ">
              {/* <ul>
                <li>
                  <a
                    title="2023 CHAIRMAN'S LETTER"
                      href="https://corporate.childrensplace.com/static/TCP2023LTR.pdf"
                  >2023
                  </a>
                </li> 
              </ul> */}

<span id="letter-design-update">
  <ul class="list-none custom-reports">
    <li class="card-position">
      <a class="mobileHoverEvent"
        href="/static/TCP2023LTR.pdf"
      target="_blank"
    >
      <div class="report-holder">
        <img
          src="https://assets.theplace.com/image/upload/q_auto/f_auto/ecom/assets/content/tcp/app_drawer/TCP-Annual-Report.jpg"
          alt="Annual Letter FY2023"
        />
        <div class="list-title">
          <div class="list-title-holder">
            <div class="list-title-area">
              <p><span></span> Annual Letter FY2023</p>
            </div>
          </div>
        </div>
      </div>
      <span class="year">2023</span>
    </a>
  </li>
  <li class="card-position">
      <a class="mobileHoverEvent"
        href="/static/TCP2024LTR.pdf"
      target="_blank"
    >
      <div class="report-holder">
        <img
          src="https://assets.theplace.com/image/upload/q_auto/f_auto/ecom/assets/content/tcp/us/homepage/TCP_2024_img.jpg"
          alt="Annual Letter FY2024"
        />
        <div class="list-title">
          <div class="list-title-holder">
            <div class="list-title-area">
              <p><span></span> Annual Letter FY2024</p>
            </div>
          </div>
        </div>
      </div>
      <span class="year">2024</span>
    </a>
  </li>
  <li class="card-position" id="card-position-left">
      <a class="mobileHoverEvent" id="card-position-left-a"
        href="/static/TCP2025LTR.pdf"
      target="_blank"
    >
      <div class="report-holder">
        <img
          src="https://assets.theplace.com/image/upload/q_auto/f_auto/v1775846306/ecom/assets/content/tcp/us/corp/new/final/png/final/new/annual_letter_2025.png"
          alt="Annual Letter FY2025"
        />
        <div class="list-title">
          <div class="list-title-holder">
            <div class="list-title-area">
              <p><span></span> Annual Letter FY2025</p>
            </div>
          </div>
        </div>
      </div>
      <span class="year">2025</span>
    </a>
  </li>
</ul>
</span>
<br></br>
<br></br>
<br></br>
<br></br>
<br></br>

{/* <span class="new-card">
<a
        href="https://corporate.childrensplace.com/static/TCP2023LTR.pdf"
      target="_blank">
  <div class="box">
    <div class="imgBox">
      <img
        src="https://assets.theplace.com/image/upload/v1737643046/ecom/assets/static/images/App_logo_TCP.png"
      />
    </div>
    <div class="content">
      <span>2028</span>
    </div>
  </div>
  </a>
  <a
        href="https://corporate.childrensplace.com/static/TCP2023LTR.pdf"
      target="_blank">
  <div class="box">
    <div class="imgBox">
      <img
        src="https://assets.theplace.com/image/upload/v1737643046/ecom/assets/static/images/App_logo_TCP.png"
      />
    </div>
    <div class="content">
      <span>2029</span>
    </div>
  </div>
  </a>
</span> */}



            </BorderedBox>
          </div>
        </div>
      </Layout>
    )
  }
}

export default ChairmanLetters


